import React from 'react';
import { NewCheckbox } from '../../../../../../../Components/PIM/common';
import { selectAllRowIds, useMeasurementsDispatch, useMeasurementsState } from '../MeasurementsProvider';

/**
 * Header checkbox that selects or clears the whole table at once (BM-9210). What "the whole table" means
 * depends on the push interaction: while a push is armed it ticks only the other products' PARENT rows,
 * making it a "push to every product" control; otherwise it ticks every POM row as a plain green bulk
 * selection that names no source. Either way it spans collapsed products and pages already loaded, and
 * stays on so later Load-More pages arrive ticked too. It reads ticked only when every applicable row is
 * selected — a partial selection leaves it empty rather than showing a dash. Uses the same PIM
 * `NewCheckbox` as the row cells so the header and row checkboxes look identical.
 */
const SelectAllHeader: React.FC = () => {
  const state = useMeasurementsState();
  const dispatch = useMeasurementsDispatch();

  const rowIds = selectAllRowIds(state);
  const selected = new Set(state.selectedRowIds);
  const selectedCount = rowIds.filter((id) => selected.has(id)).length;
  const allSelected = rowIds.length > 0 && selectedCount === rowIds.length;

  return (
    <label className="cag-checkbox">
      <NewCheckbox
        size="sm"
        checked={allSelected}
        disabled={rowIds.length === 0}
        onChange={() => dispatch({ type: 'SET_ALL_SELECTED', payload: { selected: !allSelected } })}
      />
    </label>
  );
};

export default SelectAllHeader;
